// extracted by mini-css-extract-plugin
export default {"tabs":"Sidebar_tabs__jeva7","close":"Sidebar_close__bm62V","wrapper":"Sidebar_wrapper__apb8p","overlay":"Sidebar_overlay__0HL5G"};